import React from "react";
import { formatUrl } from "utilities/formatter";

interface Props {
  website: string
}

const WebsiteLink = (props: Props) => {
  const { website } = props;

  if (website == null) return <></>;

  return <a href={website} target="_blank" rel="noreferrer noopener">{formatUrl(website)}</a>
};

export default WebsiteLink;